<template>
  <div class="layout-default">
    <header class="layout-default__header">
      <div class="layout-default__header__container">
        <h1 class="layout-default__header__logo">
          <SecurityLogoHorizontalSvg />
        </h1>

        <div
          class="layout-default__header__session"
          v-if="userProfile"
        >
          <img
            :src="userProfile.getImageUrl()"
            :alt="userProfile.getEmail()"
            class="layout-default__header__session__avatar"
            v-if="userProfile.getImageUrl()"
          >

          <a
            href="#"
            class="layout-default__header__session__link"
            @click.prevent="signOut"
          >
            Logout
          </a>
        </div>
      </div>
    </header>

    <main class="layout-default__main">
      <h2 class="layout-default__main__page-heading">
        <FontAwesomeIcon
          class="layout-default__main__page-heading__bullet"
          icon="arrow-circle-right"
        />

        Access management

        <div
          class="layout-default__main__page-heading__loading"
          v-if="isLoading"
        >
          <FontAwesomeIcon
            icon="circle-notch"
            spin
          />
        </div>
      </h2>

      <div class="layout-default__main__page-content">
        <div class="layout-default__main__page-content__nav">
          <ul>
            <li>
              <a
                href="javascript:;"
                :class="{ 'current': contentView === 'AccessManagementApplications' }"
                @click.prevent="contentView = 'AccessManagementApplications'"
              >
                Applications
              </a>
            </li>
            <li>
              <a
                href="javascript:;"
                :class="{ 'current': contentView === 'AccessManagementOwners' }"
                @click.prevent="contentView = 'AccessManagementOwners'"
              >
                Owners
              </a>
            </li>
          </ul>
        </div>

        <div class="layout-default__main__page-content__view">
          <Component :is="contentView" />
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'AccessManagementView',

  data () {
    return {
      contentView: 'AccessManagementApplications'
    }
  },

  computed: {
    ...mapState('global', ['isLoading']),
    ...mapState('auth', ['userProfile'])
  },

  provide () {
    return {
      searchItems: this.searchItems
    }
  },

  methods: {
    ...mapMutations('auth', [
      'SET_IS_SIGN_IN',
      'SET_USER_PROFILE'
    ]),

    searchItems (items, query) {
      if (!items || !query) {
        return items
      }

      return items.filter(item => {
        return Object.values(item)
          .filter(item => typeof item !== 'boolean')
          .flat()
          .join(' ')
          .toLowerCase()
          .includes(query)
      })
    },

    async signOut () {
      await this.$gAuth.signOut()
        .then((user) => {
          this.SET_IS_SIGN_IN(this.$gAuth.isAuthorized)

          if (!this.isSignIn) {
            this.SET_USER_PROFILE(null)

            this.$router.push({ name: 'login' })
          }
        })
        .catch((error) => {
          throw error
        })
    }
  }
}
</script>
